<template>
  <div class="swiper-container banner">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item, index) in datas" v-bind:key="index">
        <a :href="item.url" target="_blank"><img class="img" :src="item.img"></a>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper'
  export default {
    name: 'Form',
    props:{
      auto: {
        type: Boolean,
        default: false
      },
      loop: {
        type: Boolean,
        default: true
      },
      datas: {
        type: Array,
        default: {}
      }
    },
    watch: {
      datas: {
        handler(nval){
          const swiperObj = {
            loop: this.loop, //循环轮播
          };

          //自动轮播
          if(this.auto){
            swiperObj.autoplay = {
              delay: 3000
            }
          }

          setTimeout(()=>{
            new Swiper('.banner', swiperObj)
          },200)
        },
        immediate: true
      }
    }
  }
</script>

<style scoped lang="scss">
.img{
  width: 100%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Swiper.vue